import React from 'react';
import { Briefcase, Mail, Linkedin, Twitter, Calendar, MapPin, Award, Layers, Users } from 'lucide-react';
export const Portfolio = () => {
  return <div className="w-full bg-white min-h-screen" data-id="element-4388" data-mp="26xupwtvwet1t">
      {/* Hero Section */}
      <section className="pt-20 pb-16 border-b border-gray-200" data-id="element-4389" data-mp="2ko7xgv4vo5qm">
        <div className="container mx-auto px-4" data-id="element-4390" data-mp="2fw6eyrh49is5">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-4391" data-mp="2fvev2dwvt9hp">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-4392" data-mp="2ukaytyrwo0ci">
              <div className="w-64 h-64 border-2 border-gray-300 rounded-full overflow-hidden" data-id="element-4393" data-mp="2pmrimtbnddhx">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sGA11gNJc7vxEwMehjwPFv/dreyyyy.jpg" alt="Andrew Igbineweka" className="w-full h-full object-cover grayscale" loading="eager" width="256" height="256" data-id="element-4394" data-mp="33m0op0652r86" />
              </div>
            </div>
            <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-4395" data-mp="198j85x45iumn">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-4396" data-mp="157zdr1ayq547">
                Andrew Igbineweka
              </h1>
              <h2 className="text-2xl text-gray-600 mb-6" data-id="element-4397" data-mp="1680vzxk1pgqd">
                Human Capital Development Professional
              </h2>
              <p className="text-gray-600 mb-6 max-w-2xl" data-id="element-4398" data-mp="1g7rpbvwvdpov">
                Passionate about connecting people to networks, ideas, and
                opportunities. Experienced in community building, strategic
                partnerships, and talent development.
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start" data-id="element-4399" data-mp="1tzobzkfrr7dv">
                <a href="mailto:andrew@example.com" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4400" data-mp="1u1j0f8q91hmp">
                  <Mail size={16} className="text-gray-600" data-id="element-4401" data-mp="23wt19t4wviyw" />
                  <span data-id="element-4402" data-mp="4kqcc3dipwdu">Contact</span>
                </a>
                <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4403" data-mp="4mb6hrvx7db6">
                  <Linkedin size={16} className="text-gray-600" data-id="element-4404" data-mp="1jf4l9q6j5vx" />
                  <span data-id="element-4405" data-mp="3tnzgjf74w1tw">LinkedIn</span>
                </a>
                <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4406" data-mp="3tpagf3xgkpfq">
                  <Twitter size={16} className="text-gray-600" data-id="element-4407" data-mp="6kkvr346yl3c" />
                  <span data-id="element-4408" data-mp="kgg9yvnnb80e">Twitter</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-4409" data-mp="u8c8g7tn9055">
        <div className="container mx-auto px-4" data-id="element-4410" data-mp="u9nfqhmasq10">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4411" data-mp="p9rbch9ouwkx">
            About Me
          </h2>
          <div className="flex flex-col md:flex-row gap-12" data-id="element-4412" data-mp="146i8skzsxy7w">
            <div className="w-full md:w-2/3" data-id="element-4413" data-mp="z7fdhs9mj6d4">
              <p className="text-gray-600 mb-6" data-id="element-4414" data-mp="z8qhnt6zeg4r">
                I am a Human Capital Development Professional with expertise in
                community building, strategic partnerships, and talent
                development. My work focuses on connecting young professionals
                to networks, ideas, and opportunities worldwide.
              </p>
              <p className="text-gray-600 mb-6" data-id="element-4415" data-mp="1dst9lvecedsx">
                As the founder of The Networking Salon, I've built communities
                across multiple cities, creating platforms for meaningful
                connections and professional growth.
              </p>
              <p className="text-gray-600" data-id="element-4416" data-mp="q4a1bfvam10u">
                My approach combines strategic thinking with human-centered
                design, creating systems and experiences that help individuals
                and organizations thrive in today's rapidly evolving landscape.
              </p>
            </div>
            <div className="w-full md:w-1/3" data-id="element-4417" data-mp="l5glvhwg3zy1">
              <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4418" data-mp="l45hpgz38q6e">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4419" data-mp="1oejek9egmlsv">
                  Details
                </h3>
                <ul className="space-y-4" data-id="element-4420" data-mp="1jhjhgnzl8tdw">
                  <li className="flex items-center gap-3" data-id="element-4421" data-mp="1eprmm19eg1hy">
                    <Calendar size={20} className="text-gray-500" data-id="element-4422" data-mp="1eo6s2bn34ik3" />
                    <div data-id="element-4423" data-mp="19pwvpxpmjbww">
                      <p className="text-sm text-gray-500" data-id="element-4424" data-mp="19qolgrwjiff9">Experience</p>
                      <p className="text-gray-700" data-id="element-4425" data-mp="14sn0u2jgu81o">7+ Years</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-4426" data-mp="10op1bqq8av83">
                    <MapPin size={20} className="text-gray-500" data-id="element-4427" data-mp="vqnhv4ow4tw3" />
                    <div data-id="element-4428" data-mp="vt9s5c361ni0">
                      <p className="text-sm text-gray-500" data-id="element-4429" data-mp="qsc96xac0pfg">Location</p>
                      <p className="text-gray-700" data-id="element-4430" data-mp="qu6sk75yg9hf">Nigeria</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-4431" data-mp="2q2u3kxfeut2n">
                    <Award size={20} className="text-gray-500" data-id="element-4432" data-mp="2l6my15qxfjl8" />
                    <div data-id="element-4433" data-mp="2sq604ubv43jo">
                      <p className="text-sm text-gray-500" data-id="element-4434" data-mp="2souxixu5l1u5">Education</p>
                      <p className="text-gray-700" data-id="element-4435" data-mp="2xo7ex3299gpc">
                        MBA, University of Nigeria
                      </p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-4436" data-mp="37eiwhsev3oep">
                    <Layers size={20} className="text-gray-500" data-id="element-4437" data-mp="37dzg4g4v182s" />
                    <div data-id="element-4438" data-mp="29rjy9d8iu8ep">
                      <p className="text-sm text-gray-500" data-id="element-4439" data-mp="29sbhrpougfom">Focus Areas</p>
                      <p className="text-gray-700" data-id="element-4440" data-mp="2ep1ymf8h3fb3">
                        Community Building, Strategic Partnerships, Talent
                        Development
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Tools Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-4441" data-mp="3v6g04w85ra4q">
        <div className="container mx-auto px-4" data-id="element-4442" data-mp="3w8u8dh8appl">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4443" data-mp="200oo9pm1s7p5">
            Tools & Skills
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4444" data-mp="1v2n574omg8do">
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4445" data-mp="291d14gzpg20g">
              <div className="flex items-center gap-3 mb-4" data-id="element-4446" data-mp="250b486t9g21n">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4447" data-mp="24xx8dvqralt1">
                  <div size={20} className="text-gray-600" data-id="element-4448" data-mp="1h8cp1bqoxmj8" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4449" data-mp="1ccx98e94hgk6">
                  Strategic Planning
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4450" data-mp="1lcandk86ytb8">
                <li className="flex items-center gap-2" data-id="element-4451" data-mp="1lb910jlq6ke7">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4452" data-mp="xm7y1bvnw1gb"></div>
                  <span className="text-gray-600" data-id="element-4453" data-mp="xkdf233yajev">Stakeholder Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4454" data-mp="tis2yjz8q95q">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4455" data-mp="jfwitjjtah1d"></div>
                  <span className="text-gray-600" data-id="element-4456" data-mp="o865mqpmr0zf">SWOT Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4457" data-mp="9j08d8acrku6">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4458" data-mp="9kl3p04hr7t3"></div>
                  <span className="text-gray-600" data-id="element-4459" data-mp="eiwbl5b8788o">Project Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4460" data-mp="128gy1y6l8nmp">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4461" data-mp="176ifyfsa2gwl"></div>
                  <span className="text-gray-600" data-id="element-4462" data-mp="175quhxse9zk1">Risk Assessment</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4463" data-mp="x8cfm2m4ditu">
              <div className="flex items-center gap-3 mb-4" data-id="element-4464" data-mp="3czgsobrxacvz">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4465" data-mp="3cy5o49qnl13t">
                  <Users size={20} className="text-gray-600" data-id="element-4466" data-mp="3hzv320gzxyx6" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4467" data-mp="2z8u0t2ip0p0n">
                  Community Building
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4468" data-mp="2p9uz63wchtn5">
                <li className="flex items-center gap-2" data-id="element-4469" data-mp="2paw8a2tsw628">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4470" data-mp="2l89f9yle8f3g"></div>
                  <span className="text-gray-600" data-id="element-4471" data-mp="2la2p1mrazffo">Event Planning</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4472" data-mp="3hxqsqzqmb5fp">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4473" data-mp="3cz5qyvvpwdp5"></div>
                  <span className="text-gray-600" data-id="element-4474" data-mp="388pbz7c90k0o">Member Engagement</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4475" data-mp="3473t95d19bik">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4476" data-mp="346c5ggpogi2u"></div>
                  <span className="text-gray-600" data-id="element-4477" data-mp="4jvrlvj7pml2">Content Creation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4478" data-mp="3vxrvylucuoyc">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4479" data-mp="3vw6z2pkkitxb"></div>
                  <span className="text-gray-600" data-id="element-4480" data-mp="1ih87o3nj0jvk">Relationship Management</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4481" data-mp="1ngl3hdwdl1aa">
              <div className="flex items-center gap-3 mb-4" data-id="element-4482" data-mp="1wfey4yq5bhl7">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4483" data-mp="1wgzrwm4mywi0">
                  <Briefcase size={20} className="text-gray-600" data-id="element-4484" data-mp="21dzxkvxkpx8l" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4485" data-mp="26cb715jyi5qa">
                  Business Development
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4486" data-mp="2f5wnqufolx2c">
                <li className="flex items-center gap-2" data-id="element-4487" data-mp="2f4v1dtt7to5b">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4488" data-mp="2k50yvqm624vb"></div>
                  <span className="text-gray-600" data-id="element-4489" data-mp="2k2wiwaaztfeo">Partnership Building</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4490" data-mp="2p4dlqbd1fbxw">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4491" data-mp="1seck9z03wp76"></div>
                  <span className="text-gray-600" data-id="element-4492" data-mp="1xcecb9fifyus">Negotiation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4493" data-mp="21e9d8ctj4a81">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4494" data-mp="21cohwkze4n94"></div>
                  <span className="text-gray-600" data-id="element-4495" data-mp="2657txdifjabt">
                    Client Relationship Management
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4496" data-mp="2b65cvsb9k8ed">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4497" data-mp="2g22t7ymj1er5"></div>
                  <span className="text-gray-600" data-id="element-4498" data-mp="2l2i5snyzii82">Revenue Strategy</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4499" data-mp="2p2slwtghqp0n">
              <div className="flex items-center gap-3 mb-4" data-id="element-4500" data-mp="qpiuh71n0a6l">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4501" data-mp="upj7cn938dbj">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-4502" data-mp="n60959r9wdid"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4503" data-mp="iftkj9wrgt04">
                  Digital Tools
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4504" data-mp="dhi7kqb662do">
                <li className="flex items-center gap-2" data-id="element-4505" data-mp="de46rmi5m18c">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4506" data-mp="9g6hkjodvf4y"></div>
                  <span className="text-gray-600" data-id="element-4507" data-mp="165nvtn1fm9i9">Microsoft Office Suite</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4508" data-mp="115jgi0c9fktm">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4509" data-mp="113yi1zmtrhqh"></div>
                  <span className="text-gray-600" data-id="element-4510" data-mp="x2whnfh68zmx">Google Workspace</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4511" data-mp="s4l9d96iyx6t">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4512" data-mp="3huf53dc1tfq9"></div>
                  <span className="text-gray-600" data-id="element-4513" data-mp="3hslyfy1fqvi9">Canva</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4514" data-mp="3cual3dbxm2va">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4515" data-mp="3echn9v5z8cc1"></div>
                  <span className="text-gray-600" data-id="element-4516" data-mp="3jbu7071jx3ae">CRM Systems</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4517" data-mp="35cma5ksv279d">
              <div className="flex items-center gap-3 mb-4" data-id="element-4518" data-mp="39cwp3myms80d">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4519" data-mp="39fivhj9schh0">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-4520" data-mp="30cztf1dtq8vt"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4521" data-mp="30et3kqnnbb8k">
                  Communication
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4522" data-mp="2qmeypp19toi6">
                <li className="flex items-center gap-2" data-id="element-4523" data-mp="2qng8lq6jw4yb">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4524" data-mp="2cn5jarkw2yf9"></div>
                  <span className="text-gray-600" data-id="element-4525" data-mp="2hmicdu2ct1qa">Public Speaking</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4526" data-mp="1y0oymn6bm0mp">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4527" data-mp="1y18gk3vz0p0q"></div>
                  <span className="text-gray-600" data-id="element-4528" data-mp="1t2f48esf7425">Content Writing</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4529" data-mp="271wm0a7ath20">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4530" data-mp="26zafmdw597ld"></div>
                  <span className="text-gray-600" data-id="element-4531" data-mp="22y8c3kv729dl">Presentation Design</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4532" data-mp="2gxzwc3cb0m01">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4533" data-mp="2c0rey4yzclzu"></div>
                  <span className="text-gray-600" data-id="element-4534" data-mp="2byn93hhitcwx">Storytelling</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4535" data-mp="2lqj60p7vewzk">
              <div className="flex items-center gap-3 mb-4" data-id="element-4536" data-mp="2zpix03iuvnyw">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4537" data-mp="2znzjgkol3r0t">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-4538" data-mp="2up4o6j9fk9zt"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4539" data-mp="szpbyunxsb60">Leadership</h3>
              </div>
              <ul className="space-y-2" data-id="element-4540" data-mp="xys81plxv71u">
                <li className="flex items-center gap-2" data-id="element-4541" data-mp="12r39iwwbv0wi">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4542" data-mp="12tpp9jtdgmpt"></div>
                  <span className="text-gray-600" data-id="element-4543" data-mp="16soruxrms7e3">Team Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4544" data-mp="a490cw4ynnyc">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4545" data-mp="f1qzxvx38qto"></div>
                  <span className="text-gray-600" data-id="element-4546" data-mp="f44vs6zle72a">Mentoring</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4547" data-mp="j2ayn3xb82hx">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4548" data-mp="o2yy8dzltrnr"></div>
                  <span className="text-gray-600" data-id="element-4549" data-mp="1uisryv5m1p0c">Conflict Resolution</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4550" data-mp="1zhvn9nvsggv4">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4551" data-mp="1zgavu74rte1h"></div>
                  <span className="text-gray-600" data-id="element-4552" data-mp="29m2fv1fly4wx">Decision Making</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Experience Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-4553" data-mp="1zuxy5tyjs5ye">
        <div className="container mx-auto px-4" data-id="element-4554" data-mp="1vunr0dz0r9hy">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4555" data-mp="1vtw6by6ymw6g">
            Professional Experience
          </h2>
          <div className="space-y-8" data-id="element-4556" data-mp="1qsyhj2rg33vz">
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4557" data-mp="1lvyjnf4r17fy">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-4558" data-mp="1gwvdfrd18v6e">
                <div data-id="element-4559" data-mp="1gyydz5bta6pd">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-4560" data-mp="1cvtg5g2oet72">
                    Founder & CEO
                  </h3>
                  <p className="text-gray-600" data-id="element-4561" data-mp="3ba4ty33zxgy5">The Networking Salon</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-4562" data-mp="379b4v6ethw3o">2018 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-4563" data-mp="14mnlsszz9obg">
                <li data-id="element-4564" data-mp="19dm6e4s018ki">
                  Founded and scaled a global community initiative connecting
                  young professionals across 25+ cities worldwide
                </li>
                <li data-id="element-4565" data-mp="vkecg6gg40zn">
                  Developed strategic partnerships with organizations to create
                  opportunities for community members
                </li>
                <li data-id="element-4566" data-mp="1ndx0rhsip5af">
                  Designed and implemented community-building frameworks and
                  engagement strategies
                </li>
                <li data-id="element-4567" data-mp="1ed8lykvav0wh">
                  Led a team of city leads and volunteers to execute the vision
                  in multiple locations
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4568" data-mp="2x0o2wqtcdr5">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-4569" data-mp="7wn2h9ido01j">
                <div data-id="element-4570" data-mp="7uk1xvjlmoik">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-4571" data-mp="3vkqobetxynyx">
                    Human Capital Development Consultant
                  </h3>
                  <p className="text-gray-600" data-id="element-4572" data-mp="3rind8rb6ple6">Various Organizations</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-4573" data-mp="9chcymgv4ks1">2016 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-4574" data-mp="4fqu5rdobb2x">
                <li data-id="element-4575" data-mp="3ctzign95xfpa">
                  Provided strategic guidance on talent development and
                  organizational culture
                </li>
                <li data-id="element-4576" data-mp="37x92s119sm4e">
                  Designed and facilitated leadership development programs and
                  workshops
                </li>
                <li data-id="element-4577" data-mp="3ht3qhakcp7e1">
                  Implemented community-building strategies for corporate
                  clients
                </li>
                <li data-id="element-4578" data-mp="2u26pgsu3fuhk">Advised on employee engagement and retention strategies</li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4579" data-mp="2p2u30974wpfi">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-4580" data-mp="23n6f78a6oo2t">
                <div data-id="element-4581" data-mp="28lrdv39sezp5">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-4582" data-mp="28kyggswpxmjo">
                    Community Manager
                  </h3>
                  <p className="text-gray-600" data-id="element-4583" data-mp="2dm5l4j3ke5m4">Tech Innovation Hub</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-4584" data-mp="2igjc89b71qkz">2015 - 2018</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-4585" data-mp="2miemi3b3reaw">
                <li data-id="element-4586" data-mp="2ri9cm4n1zzuw">
                  Managed a community of tech entrepreneurs and innovators
                </li>
                <li data-id="element-4587" data-mp="2wb2i4uqcjc81">
                  Organized networking events, workshops, and skill-building
                  programs
                </li>
                <li data-id="element-4588" data-mp="369075kg15d1p">
                  Facilitated connections between community members and
                  potential investors/partners
                </li>
                <li data-id="element-4589" data-mp="3a7z8kv2jyroe">
                  Created content and communications strategies for community
                  engagement
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Brands Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-4590" data-mp="pn392aoq0h73">
        <div className="container mx-auto px-4" data-id="element-4591" data-mp="kmxd4ibf48j7">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4592" data-mp="ko8rtd6ej0p3">
            Brands I've Worked With
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8" data-id="element-4593" data-mp="1icsb8rd62naa">
            {/* Brand logos would go here - using placeholders for wireframe */}
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(item => <div key={item} className="flex items-center justify-center p-4 border border-gray-300 rounded-lg h-24" data-id="element-4594" data-mp="18ijl2ablz6fa">
                <div className="w-16 h-8 bg-gray-300 rounded-md" data-id="element-4595" data-mp="210xablivpk2r"></div>
              </div>)}
          </div>
          <p className="text-center text-gray-500 mt-8" data-id="element-4596" data-mp="1waqn9q40m7mm">
            Note: These are placeholder blocks for brand logos you've worked
            with. You'll need to add actual logos of brands from your
            experience.
          </p>
        </div>
      </section>
      {/* Contact Section */}
      <section className="py-16" data-id="element-4597" data-mp="23z9nyq9osdmi">
        <div className="container mx-auto px-4" data-id="element-4598" data-mp="240ay8sivow36">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4599" data-mp="1zxxto7fvb47z">
            Get In Touch
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-4600" data-mp="2woqa566pqyaa">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-4601" data-mp="2wnf6r7h6jsjp">
              <a href="mailto:andrew@example.com" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-4602" data-mp="2rq5954jn0aks">
                <Mail size={32} className="text-gray-600 mb-3" data-id="element-4603" data-mp="2ix1yt54agdud" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-4604" data-mp="2iwjvxpn4f1dh">Email</h3>
                <p className="text-gray-600 text-center" data-id="element-4605" data-mp="3ffhqirp4boy6">andrew@example.com</p>
              </a>
              <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-4606" data-mp="3an6fotsuaiqu">
                <Linkedin size={32} className="text-gray-600 mb-3" data-id="element-4607" data-mp="124oo3zcd0bi0" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-4608" data-mp="164ysx8of0vva">
                  LinkedIn
                </h3>
                <p className="text-gray-600 text-center" data-id="element-4609" data-mp="1b6o890io7vp6">andrewigbineweka</p>
              </a>
              <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-4610" data-mp="1g3ejnajj6349">
                <Twitter size={32} className="text-gray-600 mb-3" data-id="element-4611" data-mp="1puj0kfsrny1q" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-4612" data-mp="1tvujy3l1rn1h">
                  Twitter
                </h3>
                <p className="text-gray-600 text-center" data-id="element-4613" data-mp="1yw0d5o6ythlo">@andrewigbineweka</p>
              </a>
            </div>
            <div className="text-center" data-id="element-4614" data-mp="23ua7xxos2g6r">
              <p className="text-gray-600 mb-6" data-id="element-4615" data-mp="3r9f7ztcgaey">
                Interested in working together? I'm always open to discussing
                new projects, opportunities and partnerships.
              </p>
              <a href="mailto:andrew@example.com" className="inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-800 rounded-md hover:bg-gray-800 hover:text-white transition-colors" data-id="element-4616" data-mp="dh2h293opb60">
                <Mail size={18} data-id="element-4617" data-mp="mhqscw1p0xf7" />
                <span className="font-bold" data-id="element-4618" data-mp="mgz5c9m5w80j">Send Me a Message</span>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="py-8 border-t border-gray-200 bg-gray-50" data-id="element-4619" data-mp="wfy6760oqzcz">
        <div className="container mx-auto px-4 text-center" data-id="element-4620" data-mp="we3vekj4onmm">
          <p className="text-gray-600" data-id="element-4621" data-mp="ri4zmbvh03c6">
            &copy; {new Date().getFullYear()} Andrew Igbineweka. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>;
};